<template>
  <div>
    <Social :remember-me="rememberMe" />
    <div class="relative mt-5 sm:mt-8 text-sm text-center text-[#828282] z-10 or">
      <span class="px-4 bg-white">or</span>
    </div>
    <FormLogin
      :social-error="socialError"
      :click-source="clickSource"
      @change:remember-me="rememberMe = $event"
      @trackLoginEvent="trackLoginEvent"
    />
  </div>
</template>

<script>
import Social from './social.vue';
import FormLogin from './form.vue';

export default {
  components: {
    Social,
    FormLogin,
  },
  props: {
    clickSource: {
      type: String,
      required: true,
    },
    socialError: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rememberMe: true,
    };
  },
  watch: {
    socialError(newVal) {
      this.globalError = newVal;
    },
  },
  methods: {
    trackLoginEvent(userId) {
      this.$emit('trackLoginEvent', userId);
    },
  },
};
</script>
<style scoped>
.text-\[\#828282\] {
    color: #828282;
}
.or:before {
    content: '';
    width: 100%;
    display: block;
    height: 1px;
    background-color: #efefef;
    position: absolute;
    top: 50%;
    z-index: -1;
}
</style>
